import React, { useCallback, useEffect, useState } from "react";
import { Card, Table, Button, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import "../../../../assets/css/my-Profile.css";
import Sidebarmenu from "../../component/SidebarNavigation";
import "../../style/orderDetail.css";
import { getOrderDetails } from "../../service/OrderHistory.service";
import Breadcrumbdasbord from "../../component/Breadcrumbdasbord";

function OrderDetails() {
  const { orderNo } = useParams();
  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadOrderDetails = useCallback(async () => {
    try {
      setLoading(true);
      const decodedOrderNo = decodeURIComponent(orderNo);
      const res = await getOrderDetails(decodedOrderNo);
      if (res?.success && res?.data) {
        setOrder(res.data.order || null);
        setItems(res.data.items || []);
      } else {
        setOrder(null);
        setItems([]);
      }
    } catch (error) {
      console.error("Order Details Error:", error);

      setOrder(null);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [orderNo]);

  useEffect(() => {
    if (orderNo) {
      loadOrderDetails();
    }
  }, [orderNo, loadOrderDetails]);

  const formatAmount = (value) => {
    return Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB");
  };

  const getStatusClass = (status) => {
    switch ((status || "").toLowerCase()) {
      case "completed":
      case "delivered":
        return "status-success";
      case "pending":
      case "process":
      case "in-process":
        return "status-pending";
      case "cancelled":
        return "status-danger";
      default:
        return "status-pending";
    }
  };

  if (loading) {
    return (
      <section className="profile-section">
        <div className="container-fluid">
          <Row>
            <Col lg={2} md={3} className="border-end bg-white">
              <Sidebarmenu />
            </Col>

            <Col lg={10} md={9}>
              <div className="customer-wrapper p-4">
                Loading order details...
              </div>
            </Col>
          </Row>
        </div>
      </section>
    );
  }

  if (!order) {
    return (
      <section className="profile-section">
        <div className="container-fluid">
          <Row>
            <Col lg={2} md={3} className="border-end bg-white">
              <Sidebarmenu />
            </Col>

            <Col lg={10} md={9}>
              <div className="customer-wrapper p-4">
                <h5>Order not found</h5>

                <Link to="/my-orders">
                  Back to Orders
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    );
  }

  return (

<section className="profile-section order-details-page">
  <div className="container-fluid">
    <Row className="g-0">
      {/* Sidebar */}
      <Sidebarmenu />

      {/* Content */}
      <Col lg={10} md={9} className="order-content">
        <Breadcrumbdasbord
          title="My Orders"
          items={[
            {
              label: "My Orders",
            },
          ]}
        />

        <div className="customer-wrapper">
          <div className="Order-infromation-detail print-area">
            <Card className="order-card border-0">
              <Card.Body className="p-3 p-md-4">

                {/* =========================
                    ACTIONS
                ========================== */}
                <div className="order-actions d-flex flex-wrap gap-2 mb-4 no-print">
                  <Link to="/account/orders" className="text-decoration-none">
                    <Button
                      variant="light"
                      className="order-action-btn back-btn"
                    >
                      <i className="bi bi-arrow-left me-2"></i>
                      Back to Orders
                    </Button>
                  </Link>

                  {/* <Button
                    className="order-action-btn print-btn"
                    onClick={() => window.print()}
                  >
                    <i className="bi bi-printer me-2"></i>
                    Print Order
                  </Button> */}
                </div>

                {/* =========================
                    INFORMATION HEADER
                ========================== */}
                <div className="order-info-grid mb-4">

                  {/* CUSTOMER */}
                  <div className="order-info-box">
                    <div className="order-info-title">
                      <div className="order-info-icon">
                        <i className="bi bi-person"></i>
                      </div>
                      <h5>Customer Information</h5>
                    </div>

                    <div className="order-info-content">
                      <h6 className="customer-name">
                        {order.customer_name || "-"}
                      </h6>

                      <div className="info-row">
                        <i className="bi bi-person-badge"></i>
                        <span>
                          <strong>Contact Person:</strong>{" "}
                          {order.contact_person || "-"}
                        </span>
                      </div>

                      <div className="info-row">
                        <i className="bi bi-envelope"></i>
                        <span>
                          <strong>Email:</strong>{" "}
                          {order.email || "-"}
                        </span>
                      </div>

                      <div className="info-row">
                        <i className="bi bi-telephone"></i>
                        <span>
                          <strong>Phone:</strong>{" "}
                          {order.phone || "-"}
                        </span>
                      </div>

                      <div className="info-row">
                        <i className="bi bi-card-text"></i>
                        <span>
                          <strong>GST No:</strong>{" "}
                          {order.gst_no || "-"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* DELIVERY */}
                  <div className="order-info-box">
                    <div className="order-info-title">
                      <div className="order-info-icon">
                        <i className="bi bi-truck"></i>
                      </div>
                      <h5>Delivery Information</h5>
                    </div>

                    <div className="order-info-content">
                      <h6 className="customer-name">
                        Shipping Address
                      </h6>

                      <div className="info-row">
                        <i className="bi bi-geo-alt"></i>
                        <span>
                          <strong>Address:</strong>{" "}
                          {order.shipping_address?.address1 || "-"}
                        </span>
                      </div>

                      {order.shipping_address?.address2 && (
                        <div className="info-row">
                          <i className="bi bi-geo-alt"></i>
                          <span>
                            <strong>Address 2:</strong>{" "}
                            {order.shipping_address.address2}
                          </span>
                        </div>
                      )}

                      <div className="info-row">
                        <i className="bi bi-building"></i>
                        <span>
                          <strong>City:</strong>{" "}
                          {order.shipping_address?.city || "-"}
                        </span>
                      </div>

                      <div className="info-row">
                        <i className="bi bi-buildings"></i>
                        <span>
                          <strong>State:</strong>{" "}
                          {order.shipping_address?.state || "-"}
                        </span>
                      </div>

                      <div className="info-row">
                        <i className="bi bi-pin-map"></i>
                        <span>
                          <strong>Pincode:</strong>{" "}
                          {order.shipping_address?.pincode || "-"}
                        </span>
                      </div>

                      <div className="info-row">
                        <i className="bi bi-telephone"></i>
                        <span>
                          <strong>Phone:</strong>{" "}
                          {order.shipping_address?.phone ||
                            order.phone ||
                            "-"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* ORDER */}
                  <div className="order-info-box">
                    <div className="order-info-title">
                      <div className="order-info-icon">
                        <i className="bi bi-journal-text"></i>
                      </div>
                      <h5>Order Information</h5>
                    </div>

                    <div className="order-info-content">
                      <div className="info-row no-icon">
                        <span>
                          <strong>Order No.:</strong>{" "}
                          {order.order_no || "-"}
                        </span>
                      </div>

                      <div className="info-row no-icon">
                        <span>
                          <strong>Order Date:</strong>{" "}
                          {formatDate(order.created_at)}
                        </span>
                      </div>

                      <div className="info-row no-icon">
                        <span>
                          <strong>Invoice No.:</strong>{" "}
                          {order.invoice_no || '-'}
                        </span>
                      </div>
                     

                      <div className="info-row no-icon">
                        <span>
                          <strong>Invoice Date.:</strong>{" "}
                          {order.invoice_no || '-'}
                        </span>
                      </div>

                      <div className="info-row no-icon">
                        <span>
                          <strong>Transporter:</strong> -
                        </span>
                        <span>
                          {order.transporter_name || "-"}
                        </span>
                      </div>
                      <div className="info-row no-icon">
                        <span>
                          <strong>LR No.:</strong>{" "}
                          {order.lr_no || "-"}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>

                {/* =========================
                    PRODUCTS
                ========================== */}
                <div className="products-section">

                  <div className="section-heading">
                    <div>
                      <h5 className="mb-1">Order Items</h5>
                      <p className="mb-0">
                        Products included in this order
                      </p>
                    </div>

                    <span className="items-count">
                      {items.length}{" "}
                      {items.length === 1 ? "Item" : "Items"}
                    </span>
                  </div>

                  <div className="table-responsive order-table-wrapper">
                    <Table
                      bordered
                      hover
                      className="order-products-table align-middle mb-0"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "65px" }}>Image</th>
                          <th>Product</th>
                          <th>Design Shade</th>
                          <th>Size</th>
                          <th>Barcode</th>
                          <th className="text-center">Qty</th>
                          <th className="text-center">GST%</th>
                          <th className="text-end">Price</th>
                          <th className="text-end">Ass. Value</th>
                          <th className="text-end">Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {items.length > 0 ? (
                          items.map((item, index) => (
                            <tr
                              key={
                                item.order_detail_id || index
                              }
                            >
                              <td className="text-center">
                                {item.image_path ? (
                                  <div className="product-image-wrapper">
                                    <img
                                      src={item.image_path}
                                      alt={item.quality_name || "Product"}
                                      width="46"
                                      height="46"
                                      className="product-image"
                                    />
                                  </div>
                                ) : (
                                  <div className="product-image-empty">
                                    <i className="bi bi-image"></i>
                                  </div>
                                )}
                              </td>

                              <td>
                                <Link
                                  to="/"
                                  className="product-name"
                                >
                                  {item.quality_name || "-"}
                                </Link>
                              </td>

                              <td>
                                {item.design_shade || "-"}
                              </td>

                              <td>
                                {item.size || "-"}
                              </td>

                              <td>
                                <span className="barcode-text">
                                  {item.barcode || "-"}
                                </span>
                              </td>

                              <td className="text-center">
                                {item.quantity || 0}
                              </td>

                              <td className="text-center">
                                {item.tax_percent != null
                                  ? `${item.tax_percent}%`
                                  : "-"}
                              </td>

                              <td className="text-end amount-cell">
                                ₹
                                {formatAmount(
                                  item.selling_price
                                )}
                              </td>

                              <td className="text-end amount-cell">
                                ₹
                                {formatAmount(
                                  item.taxable_amount
                                )}
                              </td>

                              <td className="text-end amount-cell fw-semibold">
                                ₹
                                {formatAmount(
                                  item.total_amount
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="10"
                              className="empty-products"
                            >
                              <i className="bi bi-box-seam"></i>
                              <span>No products found</span>
                            </td>
                          </tr>
                        )}
                      </tbody>

                      {/* =========================
                          TOTALS
                      ========================== */}
                      <tfoot>
                        <tr>
                          <td
                            colSpan="8"
                            className="text-end"
                          >
                            Sub Total
                          </td>
                          <td
                            colSpan="2"
                            className="text-end"
                          >
                            ₹{formatAmount(order.sub_total)}
                          </td>
                        </tr>

                        <tr>
                          <td
                            colSpan="8"
                            className="text-end"
                          >
                            Tax Amount
                          </td>
                          <td
                            colSpan="2"
                            className="text-end"
                          >
                            ₹{formatAmount(order.tax_amount)}
                          </td>
                        </tr>

                        <tr className="grand-total-row">
                          <td
                            colSpan="8"
                            className="text-end"
                          >
                            Grand Total
                          </td>
                          <td
                            colSpan="2"
                            className="text-end"
                          >
                            ₹{formatAmount(order.grand_total)}
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                </div>

              </Card.Body>
            </Card>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</section>


  );
}
export default OrderDetails;